export const environment = {
  production: true,
  buildId: '2762833678318851',
  configFile: 'config.json',
};
